<template>
  <div class="app-footer" :class="{'app-footer--mobile': deviceType === 'mobile'}">
    <div class="app-footer__container">
      <!-- Logo部分 -->
      <div class="app-footer__section app-footer__logo-section">
        <div class="app-footer__logo-container">
          <img :src="domainConfig?.['siteIcon']" alt="Logo" class="app-footer__logo">
          <div class="app-footer__brand">{{domainConfig?.['siteName']}}</div>
        </div>
        <div class="app-footer__desc" v-html="domainConfig?.['ABOUTUS']"></div>
      </div>

      <!-- 资源部分 -->
      <div class="app-footer__section app-footer__resources">
        <div class="app-footer__section-title">Resources</div>
        <ul class="app-footer__links">
          <li class="app-footer__link-item">
            <a :href="getRouteUrl('about')" class="app-footer__link">About
              Us</a>
          </li>
          <li class="app-footer__link-item">
            <a :href="getRouteUrl('terms')" class="app-footer__link">Terms of
              Services</a>
          </li>
          <li class="app-footer__link-item">
            <a :href="getRouteUrl('privacy')" class="app-footer__link">Privacy
              Policy</a>
          </li>
          <li class="app-footer__link-item">
            <a :href="getRouteUrl('disclaimer')" class="app-footer__link">Disclaimer</a>
          </li>
        </ul>
      </div>

      <!-- 联系我们部分 -->
      <div class="app-footer__section app-footer__contact">
        <div class="app-footer__section-title">Contact us</div>
        <a class="app-footer__email"
          :href="`mailto:${domainConfig['IAMEMAIL']}`">{{ domainConfig?.['IAMEMAIL'] }}</a>
      </div>

      <!-- 关注我们部分 -->
      <div class="app-footer__section app-footer__follow">
        <div class="app-footer__section-title">Follow Us</div>
        <div class="app-footer__social-icons">
          <a href="javascript:void(0)" class="app-footer__social-link" @click="showToast">
            <img src="@/assets/tiktok.png" alt="TikTok" class="app-footer__social-icon">
          </a>
          <a href="javascript:void(0)" class="app-footer__social-link" @click="showToast">
            <img src="@/assets/twitter.png" alt="Twitter" class="app-footer__social-icon">
          </a>
          <a href="javascript:void(0)" class="app-footer__social-link" @click="showToast">
            <img src="@/assets/facebook.png" alt="Facebook" class="app-footer__social-icon">
          </a>
          <a href="javascript:void(0)" class="app-footer__social-link" @click="showToast">
            <img src="@/assets/instagram.png" alt="Instagram" class="app-footer__social-icon">
          </a>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="app-footer__copyright">
      Copyright © 2025 {{domainConfig?.['IAmURL']}}. All Rights Reserved.
    </div>

    <!-- Toast 提示 -->
    <div class="app-footer__toast" v-if="showToastMessage">
      <div class="app-footer__toast-content">
        to be continue
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import navigationMixin from '@/mixin/navigationMixin.js';

export default {
  name: 'AppFooter',
  mixins: [navigationMixin],
  data () {
    return {
      showToastMessage: false,
      toastTimer: null
    }
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    })
  },
  methods: {
    showToast () {
      this.showToastMessage = true;

      // 清除之前的定时器
      if (this.toastTimer) {
        clearTimeout(this.toastTimer);
      }

      // 设置新的定时器，2秒后自动关闭
      this.toastTimer = setTimeout(() => {
        this.showToastMessage = false;
      }, 2000);
    }
  },
  beforeDestroy () {
    // 组件销毁前清除定时器
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.app-footer {
	background: #050e25;
	padding: rem(60) rem(120) rem(30);
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	color: #ffffff;
	position: relative;

	&__container {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-bottom: rem(60);
	}

	&__section {
		flex: 1;
	}

	&__logo-section {
		flex: 2;
		min-width: rem(230);
		max-width: rem(500);
	}

	&__logo-container {
		display: flex;
		align-items: flex-start;
		margin-bottom: rem(20);
	}

	&__logo {
		width: rem(24);
		height: rem(24);
		margin-right: rem(12);
	}

	&__brand {
		font-size: rem(18);
		font-weight: 700;
		color: #ffffff;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__desc {
		font-size: rem(14);
		line-height: rem(22);
		color: #848998;
		margin-bottom: rem(20);
	}

	&__section-title {
		font-size: rem(16);
		font-weight: 700;
		margin-bottom: rem(20);
		color: #ffffff;
	}

	&__links {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	&__link-item {
		margin-bottom: rem(16);
	}

	&__link {
		color: #848998;
		text-decoration: none;
		font-size: rem(14);
		transition: color 0.2s;
		display: block;

		&:hover {
			color: #ffffff;
		}
	}

	&__email {
		font-size: rem(14);
		color: #848998;
		display: block;
	}

	&__social-icons {
		display: flex;
		gap: rem(16);
	}

	&__social-link {
		display: flex;
		align-items: center;
		justify-content: center;
		width: rem(32);
		height: rem(32);
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.1);
		transition: background 0.2s;

		&:hover {
			background: rgba(255, 255, 255, 0.2);
		}
	}

	&__social-icon {
		width: rem(16);
		height: rem(16);
	}

	&__copyright {
		font-size: rem(12);
		color: #848998;
		padding-top: rem(20);
		border-top: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		text-align: left;
	}

	&__toast {
		position: fixed;
		bottom: 50%;
		transform: translateY(50%);
		left: 50%;
		transform: translateX(-50%);
		padding: rem(10) rem(20);
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		border-radius: rem(4);
		z-index: 9999;
		font-size: rem(14);
		max-width: rem(200);
		text-align: center;
	}

	// 移动端样式
	&--mobile {
		padding: rem(40) rem(16) rem(20);

		.app-footer__container {
			flex-direction: column;
			margin-bottom: rem(30);
		}

		.app-footer__section {
			margin-bottom: rem(30);
		}

		.app-footer__logo-section {
			max-width: 100%;
			min-width: 100%;
			flex: none;
		}

		.app-footer__brand {
			max-width: calc(100% - rem(36)); /* 留出logo的宽度和间距 */
		}

		.app-footer__section-title {
			margin-bottom: rem(16);
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.app-footer {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
		&__logo-section {
			margin-right: rem(50);
		}
		&__resources {
			margin-right: rem(50);
		}
		&__contact {
			margin-right: rem(50);
		}
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.app-footer {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
	}
}
</style> 